// Central site configuration — single source of truth for the public phone
// number and site URL. Override via env without code changes:
//   REACT_APP_SITE_PHONE      e.g. "(216) 245-5967"
//   REACT_APP_SITE_URL        e.g. "https://indianaaccidentaid.com"
const DISPLAY = process.env.REACT_APP_SITE_PHONE || "(216) 245-5967";
const DIGITS = DISPLAY.replace(/\D/g, ""); // e.g. 2162455967
const TEN = DIGITS.length === 11 && DIGITS.startsWith("1") ? DIGITS.slice(1) : DIGITS;

export const SITE_PHONE_DISPLAY = DISPLAY;
export const SITE_PHONE_TEL = `tel:1${TEN}`;
export const SITE_PHONE_E164 = `+1-${TEN.slice(0, 3)}-${TEN.slice(3, 6)}-${TEN.slice(6)}`;
export const SITE_URL = (process.env.REACT_APP_SITE_URL || "https://indianaaccidentaid.com").replace(/\/$/, "");
